import { handleSubmitSearch } from './autoCompleteInput';

export function mobileFilterControl(context, once) {
  if (context) {
    const mainMapContainer = once(
      'main-map-container',
      '#main-map-container',
      context
    )[0];
    const mapStatusFilter = once(
      'map-status-filter',
      '#map-status-filter',
      context
    )[0];
    const mapStatusFilterHeader = once(
      'map-status-filter-header',
      '#map-status-filter-header',
      context
    )[0];

    const submitButton = once(
      'autocomplete-submit-button',
      '#autocomplete-submit-button',
      context
    )[0];

    const searchInput = once(
      'map-autocomplete-search-input',
      '#map-autocomplete-input',
      context
    )[0];
    // Implement submit button click
    submitButton?.addEventListener('click', function (e) {
      handleSubmitSearch(searchInput.value);
    });

    // Implement mobile search collapse toggle
    const leafletMapView = once(
      'map-container',
      '#leaflet-map-view-project-map-view-map',
      context
    )[0];
    leafletMapView?.addEventListener('click', function (e) {
      mainMapContainer.dataset.show = 'false';
      mapStatusFilter.dataset.show = 'false';
      console.log('leaflet clicked');
    });

    mapStatusFilterHeader?.addEventListener('click', function (e) {
      if (mapStatusFilter.dataset.show == 'true') {
        mapStatusFilter.dataset.show = 'false';
      } else {
        mapStatusFilter.dataset.show = 'true';
      }
    });

    once(
      'mobile-search-filter-button',
      'button[data-mobile-search-filter-button]',
      context
    ).forEach(button => {
      button.addEventListener('click', function (e) {
        if (mainMapContainer.dataset.show != 'filter') {
          mainMapContainer.dataset.show = 'filter';
        } else {
          mainMapContainer.dataset.show = 'false';
          mapStatusFilter.dataset.show = 'false';
        }
      });
    });

    once(
      'mobile-search-result-header',
      'h2[data-mobile-search-result-header]',
      context
    ).forEach(button => {
      button.addEventListener('click', function (e) {
        if (mainMapContainer.dataset.show == 'list') {
          mainMapContainer.dataset.show = 'false';
        } else {
          mainMapContainer.dataset.show = 'list';
        }
      });
    });
  }
}
